import React from "react";

import logoWhite from "../logo-white.svg";

/* TEMPORARY: manual copy of the learninglab site footer
   (learninglab/app/components/Footer.tsx). Any change to the footer
   there must be applied here too, until this app moves inside the
   learning portal. */

const footerLinks = {
  uk: {
    socials: {
      facebook: "https://www.facebook.com/HydroPeptide",
      instagram: "https://www.instagram.com/hydropeptideuk/",
      youtube: "https://www.youtube.com/user/hydropeptidemedia"
    },
    links: [
      {
        label: "Our Story",
        href: "https://hydropeptide.co.uk/pages/our-story-2"
      },
      {
        label: "Our Commitment",
        href: "https://hydropeptide.co.uk/pages/commitment"
      },
      {
        label: "Privacy Policy",
        href: "https://hydropeptide.co.uk/policies/privacy-policy"
      },
      {
        label: "Cookie Policy",
        href: "https://hydropeptide.co.uk/pages/cookie-policy"
      }
    ],
    copyright: "HydroPeptide UK"
  },
  com: {
    socials: {
      facebook: "https://www.facebook.com/HydroPeptide",
      instagram: "https://www.instagram.com/hydropeptide/",
      youtube: "https://www.youtube.com/user/hydropeptidemedia"
    },
    links: [
      { label: "Our Story", href: "https://hydropeptide.com/pages/our-story" },
      {
        label: "Privacy Policy",
        href: "https://hydropeptide.com/policies/privacy-policy"
      },
      {
        label: "Cookie Policy",
        href: "https://hydropeptide.com/pages/cookie-policy"
      }
    ],
    copyright: "HydroPeptide Inc."
  }
};

const PortalFooter = props => {
  const variant = footerLinks[props.portal] || footerLinks.com;
  const { socials, links, copyright } = variant;

  return (
    <footer className="ll-footer">
      <div className="ll-footer-inner">
        {/* Left: logo + blurb */}
        <div className="ll-footer-left">
          <img
            src={logoWhite}
            alt="HydroPeptide"
            className="ll-footer-logo"
          />
          <p className="ll-footer-blurb">
            With over 20 years of experience in professional skincare,
            we&rsquo;ve been at the forefront of peptide
            technology&mdash;creating scientifically-advanced, easy-to-use
            products.
          </p>

          {/* Socials */}
          <div className="ll-footer-socials">
            <a
              href={socials.facebook}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <svg viewBox="0 0 24 24" className="ll-footer-social-icon">
                <path d="M22 12a10 10 0 1 0-11.6 9.9v-7H7.7V12h2.7V9.8c0-2.7 1.6-4.2 4-4.2 1.2 0 2.4.2 2.4.2v2.6h-1.4c-1.4 0-1.9.9-1.9 1.8V12h3.2l-.5 2.9h-2.7v7A10 10 0 0 0 22 12z" />
              </svg>
            </a>
            <a
              href={socials.instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <svg viewBox="0 0 24 24" className="ll-footer-social-icon">
                <path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm0 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7zm5 3.5a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11zm0 2a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zm5.75-.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
              </svg>
            </a>
            <a
              href={socials.youtube}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <svg viewBox="0 0 24 24" className="ll-footer-social-icon">
                <path d="M23.5 7.2a3 3 0 0 0-2.1-2.1C19.7 4.5 12 4.5 12 4.5s-7.7 0-9.4.6A3 3 0 0 0 .5 7.2 31.8 31.8 0 0 0 0 12a31.8 31.8 0 0 0 .5 4.8 3 3 0 0 0 2.1 2.1c1.7.6 9.4.6 9.4.6s7.7 0 9.4-.6a3 3 0 0 0 2.1-2.1c.4-1.6.5-3.2.5-4.8s0-3.2-.5-4.8zM9.8 15.2V8.8l6 3.2-6 3.2z" />
              </svg>
            </a>
          </div>

          <p className="ll-footer-copyright">
            &copy; {new Date().getFullYear()} {copyright}. All rights
            reserved.
          </p>
        </div>

        {/* Right: links */}
        <div className="ll-footer-right">
          <h3 className="ll-footer-heading">About</h3>
          <ul className="ll-footer-links">
            {links.map(({ label, href }) => (
              <li key={href}>
                <a href={href} target="_blank" rel="noopener noreferrer">
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default PortalFooter;
